import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import fm from 'front-matter';
import rehypeRaw from 'rehype-raw'; // Allows raw HTML rendering
import styles from '../styles/Blog.module.css';

function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    const fetchPost = async () => {
      // Find the file for this slug in the manifest, then fetch just that post.
      const manifest = await (await fetch('/posts/manifest.json')).json();
      const entry = manifest.find((p) => p.slug === slug);
      if (!entry) {
        setPost(null);
        return;
      }
      const text = await (await fetch(entry.file)).text();
      const { attributes, body } = fm(text);
      setPost({ attributes, body });
      window.scrollTo(0, 0);
    };
    fetchPost();
  }, [slug]);

  if (post === undefined) {
    return (
      <div className={styles.blogContainer}>
        <p className={styles.description}>Loading…</p>
      </div>
    );
  }

  if (post === null) {
    return (
      <div className={styles.blogContainer}>
        <h1 className={styles.title}>Post not found</h1>
        <Link to="/blog" className={styles.toggleButton}>
          ← Back to all writing
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.blogContainer}>
      <div className={styles.post}>
        <h1 className={styles.postTitle}>{post.attributes.title}</h1>
        <p className={styles.dek}>{post.attributes.dek}</p>
        <p className={styles.date}>{post.attributes.date}</p>
        {post.attributes.image && (
          <img
            src={post.attributes.image}
            alt={post.attributes.alt || post.attributes.title}
            className={styles.postImage}
          />
        )}
        <ReactMarkdown className={styles.content} rehypePlugins={[rehypeRaw]}>
          {post.body}
        </ReactMarkdown>
        <Link to="/blog" className={styles.toggleButton}>
          ← Back to all writing
        </Link>
      </div>
    </div>
  );
}

export default BlogPost;
